"use client";

// src/breadcrumb.tsx
import { cn } from "@momo/utils";
import { Slot } from "@radix-ui/react-slot";
import { ChevronRightIcon, MoreHorizontalIcon } from "lucide-react";
import { jsx } from "react/jsx-runtime";
var Breadcrumb = (props) => /* @__PURE__ */ jsx("nav", { "aria-label": "breadcrumb", ...props });
var BreadcrumbList = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "ol",
    {
      className: cn(
        "text-muted-foreground flex flex-wrap items-center gap-1.5 break-words text-sm sm:gap-2.5",
        className
      ),
      ...rest
    }
  );
};
var BreadcrumbItem = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("li", { className: cn("inline-flex items-center gap-1.5", className), ...rest });
};
var BreadcrumbLink = (props) => {
  const { asChild, className, ...rest } = props;
  const Comp = asChild ? Slot : "a";
  return /* @__PURE__ */ jsx(Comp, { className: cn("hover:text-foreground transition-colors", className), ...rest });
};
var BreadcrumbPage = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "span",
    {
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: cn("text-foreground font-normal", className),
      ...rest
    }
  );
};
var BreadcrumbSeparator = (props) => {
  const { children, className, ...rest } = props;
  return /* @__PURE__ */ jsx("li", { role: "presentation", "aria-hidden": "true", className: cn(className), ...rest, children: children ?? /* @__PURE__ */ jsx(ChevronRightIcon, { className: "size-3.5" }) });
};
var BreadcrumbEllipsis = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "span",
    {
      role: "presentation",
      "aria-hidden": "true",
      className: cn("flex size-9 items-center justify-center", className),
      ...rest,
      children: /* @__PURE__ */ jsx(MoreHorizontalIcon, { className: "size-4" })
    }
  );
};

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis
};
